var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"result"},[_c('h2',[_vm._v("报名成功")]),_c('p',[_vm._v("后续安排请关注“山西博物院”公众号")])])])
}]

export { render, staticRenderFns }